import { project } from '@/lib/project';
import { useEffect } from 'react';

const loadAds = ({ query, id, totalAds, locale }) => {
	try {
		if (typeof window !== 'undefined' && window._googCsa) {
			const pageOptions = {
				pubId: `partner-${project.adSense.accountId}`,
				query: query,
				styleId: project.adSense.afs,
				adsafe: 'low',
				number: totalAds,
				hl: locale,
			};
			const adblock = {
				container: id,
				adLoadedCallback: function (
					containerName,
					adsLoaded,
					isExperimentVariant,
					callbackOptions
				) {
					if (!adsLoaded) {
						try {
							document
								.querySelector('#' + containerName)
								.parentNode.classList.add('hidden');
						} catch (error) {
							console.log('adsense search error', error.message, containerName);
						}
					} else {
					}
				},
			};
			window._googCsa('ads', pageOptions, adblock);
		}
	} catch (error) {
		console.log('adsense search error', error.message);
	}
};

export default function GoogleAdSearch({
	index,
	query,
	totalAds = 1,
	locale = 'en',
}) {
	let id = `afscontainer_${index}`;

	useEffect(() => {
		loadAds({ query, id, totalAds, locale });
	}, [query, id, totalAds, locale]);
	return <div key={id} id={id} />;
}
